<template>
  <div class="app-container">
    <el-card>
      <div slot="header" class="clearfix">
        <h3 class="pageName">加盟学校</h3>
      </div>
      <el-form :model="queryParams" ref="queryForm" :inline="true" size="small" class="">
        <el-form-item label="" prop="title">
          <el-input v-model="queryParams.title" placeholder="标题" @keyup.enter.native="handleQuery" @change="$forceUpdate()"></el-input>
        </el-form-item>

        <el-form-item label="" prop="feedbackTatus">
          <el-select filterable v-model="queryParams.feedbackTatus" placeholder="处理状态" clearable @change="$forceUpdate()">
            <el-option v-for="(item, index) in feedbackTatusArr" :key="index" :label="item.name" :value="item.value" />
          </el-select>
        </el-form-item>

        <el-form-item label="" prop="time">
          <el-date-picker v-model="queryParams.time" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']" range-separator="-" start-placeholder="开始时间"
            end-placeholder="结束时间" @change="$forceUpdate()"></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="loading" element-loading-text="加载中" :data="list">
        <el-table-column label="序号" align="center" type="index" width="50" />
        <el-table-column label="姓名" align="center" prop="name" />
        <el-table-column label="手机号" align="center" prop="mobile" />
        <el-table-column label="目前定居城市" align="center" prop="habitableCity" />
        <el-table-column label="意向学校" align="center" prop="intendedSchool" />
        <el-table-column label="备选城市" align="center" prop="superiority" />
        <el-table-column label="个人优势" align="center" prop="superiority" />
        <el-table-column label="状态" align="center" prop="feedbackTatus">
          <template slot-scope="scope">
            <span class="statusTag success" v-if="scope.row.feedbackTatus == 1"> 待处理 </span>
            <span class="statusTag danger" v-if="scope.row.feedbackTatus == 2"> 已处理 </span>
          </template>
        </el-table-column>
        <el-table-column label="提交时间" align="center" prop="createTime"></el-table-column>
        <el-table-column label="处理人" align="center" prop="handleBy"></el-table-column>
        <el-table-column label="处理时间" align="center" prop="handleTime"></el-table-column>
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <!-- <el-button size="small" type="primary" @click="handleDtl(scope.row)">详情</el-button> -->
            <el-button size="small" type="success" icon="el-icon-check" @click="handleEdit(scope.row)"
              v-if="scope.row.feedbackTatus == 1">标记处理</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize"
        @pagination="_getList" />
    </el-card>

  </div>
</template>

<script>
import * as API_Msg from "@/api/sportManage/msg";
export default {
  name: "msgList",
  data() {
    return {
      queryParams: {
        title: null,
        feedbackTatus: null,
        pageNum: 1,
        pageSize: 10,
        time: [],
      },
      loading: false,
      total: 0,
      list: [],
      feedbackTatusArr: [
        {
          name: '全部',
          value: null
        },
        {
          name: '待处理',
          value: 1
        },
        {
          name: '已处理',
          value: 2
        }
      ],
      editInfo: {}
    };
  },
  created() {
    this._getList()
  },
  methods: {
    handleQuery() {
      this.queryParams.startTime = this.queryParams.time ? this.queryParams.time[0] : "";
      this.queryParams.endTime = this.queryParams.time ? this.queryParams.time[1] : "";
      this.queryParams.pageNum = 1;
      this._getList();
    },
    resetQuery() {
      this.$refs["queryForm"].resetFields();
      this.queryParams.startTime = ''
      this.queryParams.endTime = ''
      this._getList();
    },

    _getList() {
      API_Msg.joinSchoolList(this.queryParams).then((res) => {
        console.log(res);
        this.total = res.data.total;
        this.list = res.data.list;
      })
    },

    handleEdit(e) {
      this.$alert('确认标记处理该条信息', '提示', {
        confirmButtonText: '确定',
        callback: action => {
          if (action == 'confirm') {
            this.confirm(e)
          }
        }
      });
    },

    confirm(e) {
      let params = {
        id: e.id,
        feedbackTatus: 2,
      }
      API_Msg.joinSchoolState(params).then((res) => {
        console.log(res);
        this._getList()
      })
    },

  },
};
</script>

<style lang="scss">
.imgBox {
  width: 100px;
  height: 100px;
  position: relative;
  display: inline-block;

  img {
    width: 100%;
  }
}
</style>
